import VerifiedIcon, { VerifiedIconCheckmark, VerifiedIconCircle } from './verifiedIcon';

export { VerifiedIconCheckmark, VerifiedIconCircle };
export default VerifiedIcon;
